import { FC } from "react";
import { observer } from "mobx-react";
import { Dialog } from "../components-v2/Dialog";
import { useTranslation } from "../stores/RootStoreContext";
import { MDateInput } from "../components-v2/DateInput";
import { VBox } from "../components-v2/Box";
import { LocalDateFieldModel } from "../common/commonForms";
import { DataTable } from "../components-v2/DataTable";
import { AutotextCategory, AutotextProps, autotextVariables } from "./autotext";

export const AutotextDialog: FC<AutotextProps> = observer(
  ({ autotextOption, perDate, onCancel, onSelectedVariable }) => {
    const { t } = useTranslation();

    return (
      <Dialog title={autotextOption.dialogTitle} onCancel={onCancel}>
        <VBox gap={"md"}>
          {autotextOption.type === AutotextCategory.companyInformation && (
            <PerDateInput perDate={perDate} />
          )}
          <DataTable
            variant={"COMPACT"}
            hoverable
            tableData={autotextVariables[autotextOption.type]}
            tableColumns={[
              { name: "name", label: t("autotext.title"), getValue: (v) => v.label, align: "left" },
              {
                name: "variable",
                label: t("autotext.variable"),
                getValue: (v) => <span className={"dc-variable"}>{v.placeholderValue}</span>,
                align: "right",
              },
            ]}
            getId={(v) => v.placeholderValue}
            onRowClick={({ placeholderValue }) =>
              onSelectedVariable(placeholderValue, perDate?.inputValue)
            }
          />
        </VBox>
      </Dialog>
    );
  },
);

const PerDateInput: FC<{ perDate: LocalDateFieldModel | undefined }> = observer(({ perDate }) => {
  const { t } = useTranslation();
  if (!perDate) {
    return null;
  }
  return (
    <VBox>
      <div>{t("dbot.per-date")}</div>
      {perDate && <MDateInput model={perDate} />}
    </VBox>
  );
});
